// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".Box-module-box-3H6HV{border-radius:8px;background-color:#fcfcfc;padding:24px}.Box-module-box-3H6HV.Box-module-boxAccent-2b2cb{background-color:rgba(210,210,210,.25)}.Box-module-boxTitle-3iJwx{text-transform:uppercase;letter-spacing:3.5px;line-height:20px;font-size:14px;font-weight:400;margin-bottom:40px !important}", ""]);
// Exports
exports.locals = {
	"box": "Box-module-box-3H6HV",
	"boxAccent": "Box-module-boxAccent-2b2cb",
	"boxTitle": "Box-module-boxTitle-3iJwx"
};
module.exports = exports;
